import { render, staticRenderFns } from "./AddonProductNew.vue?vue&type=template&id=e539961a&scoped=true&"
import script from "./AddonProductNew.vue?vue&type=script&lang=js&"
export * from "./AddonProductNew.vue?vue&type=script&lang=js&"
import style0 from "./AddonProductNew.vue?vue&type=style&index=0&id=e539961a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e539961a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\corporate-builder\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e539961a')) {
      api.createRecord('e539961a', component.options)
    } else {
      api.reload('e539961a', component.options)
    }
    module.hot.accept("./AddonProductNew.vue?vue&type=template&id=e539961a&scoped=true&", function () {
      api.rerender('e539961a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CorporateBuilder/components/AddonProductNew.vue"
export default component.exports